/**
 * @author xyguo
 * @description 角色管理==》人员维护==》添加人员==》在该角色下通过上传excel批量添加人员  待完善。。。
 * @Date 2020/1/2
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool } from '../../../../../tool'
import 'antd/dist/antd.css';
import { Row, Col ,Input} from 'antd';
const { TextArea } = Input;
let { WizContainer, WizReduxTemplatem, modelUtils } = framework_tool;
import { ExportExcel } from '@/components/index'
let { WizCard, WizLayout, WizIcon,WizSpin,WizTypography } = component_tool;
const { Paragraph } = WizTypography;

import cx from 'classnames';
class RoleUserImport extends WizContainer {

  componentName = 'RoleUserImport';

  constructor(props) {
    super(props);
    this.state = {
      name: null,
    }
  }


  _handldImport(nextProps, nextState) {
    let o = nextProps['roleUserImports']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      wizNotice.success({
        key:'default',
        message:'成功',
        description: (
          <div>
            <p style={{whiteSpace: "pre-line"}}>{str}</p>
          </div>
        ),
      })
      return true;
    } else {
      wizNotice.error("导入数据出错，请联系相关人员")
      return false;
    }
  }

  propsAndStateOnChange = {
    roleUserImports: this._handldImport.bind(this),
  }


  _render() {
    let roleId = this.props.roleId;
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '角色人员导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_roleUserTemp,
      }

    }
    let submit = (file, fileData) => {
      let apiPath = 'roleUser/import';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData,
            "roleId":roleId
          }
        }
      });
    }
    let { roleUserLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={roleUserLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}

  // _render() {
  //   return (
  //       <WizLayout key={this.componentName + '@Layout'}>
  //         <WizLayout.Header>
  //           <Row>
  //             <Col span={2} >
  //               <WizIcon type="question-circle" />
  //               <span className="header-icon-font">导入说明</span>
  //             </Col>
  //             <Col span={10} push={1}>
  //               <div className="header-font">1. 从右侧的链接中下载人员导入的模版文件；</div>
  //               <div className="header-font">2. 按要求格式填写人员信息；</div>
  //               <div className="header-font">3. 当完成Excel文件的填写后，点击“上传文件”按钮上传此文件，并点击“导入”系统会校验数据的正确性，并提示错误的数据；在校验无错误的情况下，将数据导入到系统中。</div>
  //             </Col>
  //             <Col span={12} push={1}>
  //             </Col>
  //           </Row>
  //           <span className="header-icon-font" >选择文件</span>
  //       <WizCard>

  //           <TextArea  />

  //       </WizCard>

  //         </WizLayout.Header>
  //       </WizLayout>
  //   )
  // }


const mapStateToProps = (state, ownProps) => {
  // return {};
  const { roleUser } = state;
  const roleUserImports = modelUtils.getModelEntity(roleUser, 'import');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'roleUser')
  return {
    roleUserImports: roleUserImports,
    ...load
  }
};

export default connect(mapStateToProps)(RoleUserImport);
